import React from 'react';
import { Link } from 'react-router-dom';
import { useSite } from '../../context/SiteContext';

export const Footer = () => {
  const { settings, footerLinks } = useSite();

  if (!settings) return null;

  return (
    <footer className="bg-slate-900 text-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="font-heading text-2xl font-bold">{settings.site_name}</h3>
            <p className="mt-2 text-slate-400 text-sm max-w-md">
              {settings.site_tagline}
            </p>
            <div className="mt-4 flex items-center gap-4">
              <span className="px-3 py-1 bg-slate-800 rounded text-xs font-semibold">
                60-Day Guarantee
              </span>
              <span className="px-3 py-1 bg-slate-800 rounded text-xs font-semibold">
                Secure Checkout
              </span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-slate-400">
              Quick Links
            </h4>
            <ul className="mt-4 space-y-2">
              {footerLinks.map((link) => (
                <li key={link.id}>
                  {link.is_external ? (
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-slate-400 hover:text-white transition-colors"
                      data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                      {link.label}
                    </a>
                  ) : (
                    <Link
                      to={link.url}
                      className="text-sm text-slate-400 hover:text-white transition-colors"
                      data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-slate-400">
              Legal
            </h4>
            <div className="mt-4 text-sm text-slate-400 space-y-2">
              <p>These statements have not been evaluated by the Food and Drug Administration.</p>
              <p>This product is not intended to diagnose, treat, cure, or prevent any disease.</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-500">
            © {new Date().getFullYear()} {settings.site_name}. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <img src="https://placehold.co/60x30/1e293b/ffffff?text=VISA" alt="Visa" className="h-6 opacity-60" />
            <img src="https://placehold.co/60x30/1e293b/ffffff?text=MC" alt="Mastercard" className="h-6 opacity-60" />
            <img src="https://placehold.co/60x30/1e293b/ffffff?text=AMEX" alt="Amex" className="h-6 opacity-60" />
            <img src="https://placehold.co/60x30/1e293b/ffffff?text=PP" alt="PayPal" className="h-6 opacity-60" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
